import { render, staticRenderFns } from "./TrainingSwallow.vue?vue&type=template&id=30f4b463&scoped=true&"
import script from "./TrainingSwallow.vue?vue&type=script&lang=js&"
export * from "./TrainingSwallow.vue?vue&type=script&lang=js&"
import style0 from "./TrainingSwallow.vue?vue&type=style&index=0&id=30f4b463&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f4b463",
  null
  
)

export default component.exports